<template>
    <div>
        <p>
            If space is available on your calendar, you may add you Location Key
            here. You may use up to 8 lines. Once your Location Keys are
            complete, proofread them carefully. This is the only screen that
            will allow you to edit your Location Key. Your Location Key will NOT
            appear on your proof. The information from the previous calendar
            will be listed here.
        </p>
        <el-form class="location-keys" @submit.prevent label-width="100px">
            <el-form-item
                v-for="(location_key, index) in form.location_keys"
                :key="index"
                :label="'Line ' + (index + 1)"
            >
                <el-input v-model="location_key.key" />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style scoped>
.location-keys {
    max-width: 500px;
}
</style>
